$(document).ready(function () {

  // Below Hero Nav Transition
  if($(".hero").length) {

    var threshold = $(".hero").first().outerHeight() - 100;
    if ($(window).scrollTop() >= threshold) setNavType("grayWithBar");
    if ($(window).scrollTop() < threshold) setNavType("white");

    // Transition nav past hero scroll
    $(window).scroll(function () {
      var threshold = $(".hero").first().outerHeight() - 100;
      if ($(window).scrollTop() >= threshold) setNavType("grayWithBar");
      if ($(window).scrollTop() < threshold) setNavType("white");
    });

  }

  // Toggle Mobile Menu Navigation
  $("#mobile-menu-toggle").click(function (e) {
    e.preventDefault();
    $(".navigation").toggleClass("mobile-nav-open");
    $("body").toggleClass("fixed");
  });

  // Show/Hide Mobile Menu Navigation Based On Width
  $(window).on("resize", function () {
    if($(window).width() > breakpoints.small && $(".navigation").hasClass("mobile-nav-open")) {
      $(".navigation").removeClass("mobile-nav-open");
      $("body").removeClass("fixed");
    }
  });

});

function setNavType(newNavType) {
  var navClassRegex = /navType-([^\s-]+)/;
  var currentNavType = navClassRegex.test($('.navigation').attr("class")) ? $('.navigation').attr("class").match(navClassRegex)[1] : "";
  if(currentNavType != newNavType) {
    $('.navigation').removeClassRegex(navClassRegex); //defined in
    $('.navigation').addClass("navType-" + newNavType);
  }
}